export default __webpack_public_path__ + "static/media/big.63ed7bdb.svg";